import { render, staticRenderFns } from "./BookingsOpened.vue?vue&type=template&id=32f37c4c&"
import script from "./BookingsOpened.vue?vue&type=script&lang=js&"
export * from "./BookingsOpened.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports